<template>
  <section class="timeline timeline_chat" :class="{open: chat_list}">
    <div class="timeline-scroll">

      <div class="timeline-header">
        <div class="timeline-header_left" v-if="!open_search && my">
          <h2 class="timeline-title">Чаты</h2>
          <Loader color="black" v-if="loader_more" />
        </div>
        <div class="search" v-if="open_search || !my">
          <div class="input-search">
              <input type="search" placeholder="Поиск" v-model="search" @keyup="setChatCaption" ref="search">
              <img src="@/assets/images/icons/icon_search-b.svg" width="22px">
          </div>
        </div>

        <div class="search-buttons">
          <div class="search-icon" v-if="!open_search" @click="changeOpenSearch()">
            <img src="@/assets/images/icons/icon_search-b.svg" width="22px" />
          </div>
          <div class="search-close" v-if="open_search" @click="changeOpenSearch()">
            <img src="@/assets/images/icons/icon_close.svg" width="22px" />
          </div>
        </div>
      </div>
      <div class="timeline-filters">
        <div class="timeline-string">
          <div class="timeline-buttons">
            <div class="button" :class="{active: my }" @click="changeType(true)">Мои чаты</div>
            <div class="button" :class="{active: !my}" @click="changeType(false)">Глобальный поиск</div>
          </div>
        </div>
      </div>
      <div class="timeline-body">
        <div class="timeline-chat" v-if="!loader && dialogs && dialogs.length > 0">
          <Dialog v-for="dialog of dialogs" :key="dialog.id" :dialog="dialog" />
        </div>
        <div class="timeline-chat" v-if="loader || local_load">
          <DialogPseudo v-for="dialog of 4" :key="dialog" />
        </div>
        <div class="timeline-nothing" v-if="dialogs && dialogs.error">
          <p>Что-то пошло не так...</p>
        </div>
        <div class="timeline-nothing" v-if="!loader && (!dialogs || dialogs.length === 0)">
          <p>Ничего не найдено 💩</p>
        </div>
      </div>
    </div>
    <div class="timeline-footer">
      <div class="timeline-add" @click="newChat()">
        <p>Создать чат</p>
        <img src="@/assets/images/icons/icon_plus.svg" width="22px" />
      </div>
    </div>
  </section>
</template>

<script>
import Dialog from './Dialog'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faUsersCog,faSignOutAlt, faUserPlus, faBellSlash, faLockOpen, faLock, faBell} from '@fortawesome/free-solid-svg-icons'
library.add(faTrashAlt, faUsersCog,faSignOutAlt, faUserPlus, faBellSlash, faLockOpen, faLock, faBell)

export default {
  props: {
    dialogs: {
      type: Array,
      required: false,
    },
    loader: {
      type: Boolean,
      required: true,
    },
    loader_more: {
      type: Boolean,
      required: false,
    },

  },
  components: {
    Dialog,
    Loader: () => import('@/components/UI/Loader'),
    DialogPseudo: () => import("./DialogPseudo.vue"),
  },
  data() {
    return {
      search: "",
      my: true,
      page: 1,
      open_search: false,
      local_load: false
    };
  },
  computed:{
    chat_list() {
      return this.$store.getters.chat_list
    }
  },
  sockets: {
    new_message (message) {
      let finded = this.dialogs.find(dialog => dialog.id == message.chat);
      finded ? this.dialogs.splice(0, 0, this.dialogs.splice(this.dialogs.indexOf(finded), 1)[0]) : '';
    }
  },
  methods: {
    changeOpenSearch() {
      this.open_search = !this.open_search
      !this.open_search || this.search.length > 0
        ? (this.search = '', this.setChatCaption()) 
        : this.focusOnSearch()
    },
    focusOnSearch() {
      setTimeout(() => {
        let search = this.$refs.search;
        search ? search.focus() : ''
      }, 100)
    },
    newChat() {
      this.$store.dispatch('changeState', {element: 'new_chat', val: true})
    },
    changeType (my) {
      this.my = my;
      this.page = 0;
      this.setChatCaption();
    },
    async setChatCaption(from) {
      from === 'input' ? this.page = 0 : '';
      this.local_load = true
      this.search.length > 2 || this.search.length === 0 
        ? await this.$store.dispatch('setChatSearch', {caption: this.search, my: this.my, page: this.page}) 
        : '';
      this.local_load = false
    },
    lazyLoad() {
      let timeline = document.querySelector('.timeline-scroll');
      timeline.addEventListener('scroll', async () => {
        let bottom = timeline.scrollTop + timeline.clientHeight >= timeline.scrollHeight;
        if (bottom && !this.my) {
          this.page++;
          this.setChatCaption();
        }
      })
    }
  },
  watch: {
    $route(to) {
      to.name === 'chat' ? this.$store.dispatch('changeState', {element: 'chat_list', val: false}) : ''
      to.name === 'messages' ? this.$store.dispatch('changeState', {element: 'chat_list', val: true}) : ''
    }
  },
  mounted() {
    this.lazyLoad()
  }
};
</script>
<style lang="stylus" scoped>
.timeline-chat {
  width: 100%;
  padding: 8px 0;
}
</style>